
export const ACTUAL_SALES_POSTING = (state, value) => {
  state.actualSalesPosting = value
}

export const ACTUAL_SALES_ERRORS = (state, value) => {
  state.actualSalesErrors = value
}

export const ACTUAL_SALES_TOTALS = (state, value) => {
  state.actualSalesTotals = value
}

export const ACTUAL_SAELS_POSTED = (state, value) => {
  state.actualSalesPosted = value
}


export const MAIN_LIST_QUICK_FILTER = (state, value) => {
  state.mainListQuickFilters = value
}

export const QUICK_FILTERS_DATES_FROM = (state, value) => {
  state.quickFiltersDatesFrom = value
}

export const QUICK_FILTERS_DATES_TO = (state, value) => {
  state.quickFiltersDatesTo = value
}